// extracted by mini-css-extract-plugin
module.exports = {"DisclaimerModal":"_11kf9B6KNSgtokR6DxjivB","DisclaimerModal__close":"_1UvqZZ-ygON3PIb-jXpfl_"};